import {
  PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY
} from "./chunk-ASIPNTK6.js";
import {
  BaseItemModel_default
} from "./chunk-UPAELC5I.js";
import {
  BaseModel_default
} from "./chunk-ITJMNR7M.js";

// src/Pim/PimDebtorGroup/PimDebtorGroupModel.ts
var DebtorGroupModel = class extends BaseModel_default {
  constructor(entities) {
    super(entities);
    if (entities) {
      this.items = entities._embedded.item.map((element) => {
        return new DebtorGroupItemModel(element);
      });
    }
  }
};
var DebtorGroupItemModel = class extends BaseItemModel_default {
  constructor(entity) {
    super(entity);
    this.id = null;
    this.title = null;
    this.published = 0;
    this.featured = 0;
    this.created_user_name = null;
    this.modified_user_name = null;
    this.created_time = null;
    this.custom_fields = null;
    this.organisation_name = null;
    this.modified_time = null;
    this.toObject = () => {
      return {};
    };
    this.toJSON = () => {
      return {
        ...this.baseToJSON(),
        [PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.ID]: this.id,
        [PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.TITLE]: this.title,
        [PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.PUBLISHED]: this.published,
        [PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.FEATURED]: this.featured,
        [PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.CREATED_USER_NAME]: this.created_user_name,
        [PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.MODIFIED_USER_NAME]: this.modified_user_name,
        [PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.CREATED_TIME]: this.created_time,
        [PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.CUSTOM_FIELDS]: this.custom_fields,
        [PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.ORGANISATION_NAME]: this.organisation_name,
        [PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.MODIFIED_TIME]: this.modified_time
      };
    };
    if (entity) {
      this.id = entity[PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.ID] ?? "";
      this.title = entity[PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.TITLE] ?? "";
      this.published = entity[PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.PUBLISHED] ?? "";
      this.featured = entity[PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.FEATURED] ?? "";
      this.created_user_name = entity[PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.CREATED_USER_NAME] ?? "";
      this.modified_user_name = entity[PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.MODIFIED_USER_NAME] ?? "";
      this.created_time = entity[PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.CREATED_TIME] ?? "";
      this.custom_fields = entity[PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.CUSTOM_FIELDS] ?? "";
      this.organisation_name = entity[PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.ORGANISATION_NAME] ?? "";
      this.modified_time = entity[PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.MODIFIED_TIME] ?? "";
    }
  }
};
DebtorGroupItemModel.__transformItemToApiOfCreation = (data) => {
  let formData = new FormData();
  const excluded = [
    PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.ID,
    PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.CUSTOM_FIELDS
  ];
  Object.keys(PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY).forEach((index) => {
    if (!excluded.includes(PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY[index]) && data[PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY[index]]) {
      formData.append(
        PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY[index],
        data[PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY[index]]
      );
    }
  });
  if (data[PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.CUSTOM_FIELDS] && Object.keys(data[PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.CUSTOM_FIELDS]).length) {
    Object.keys(data[PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.CUSTOM_FIELDS]).forEach(function(key) {
      formData.append(
        [PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.CUSTOM_FIELDS] + "[" + key + "]",
        data[PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.CUSTOM_FIELDS][key]
      );
    });
  }
  return formData;
};
DebtorGroupItemModel.__transformItemToApiOfUpdation = (data) => {
  let formData = {};
  const excluded = [PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.CUSTOM_FIELDS];
  Object.keys(PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY).forEach((index) => {
    if (!excluded.includes(PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY[index]) && data[PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY[index]]) {
      formData[PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY[index]] = data[PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY[index]];
    }
  });
  if (data[PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.CUSTOM_FIELDS] && Object.keys(data[PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.CUSTOM_FIELDS]).length) {
    formData[PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.CUSTOM_FIELDS] = {};
    Object.keys(data[PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.CUSTOM_FIELDS]).forEach(function(key) {
      formData[PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.CUSTOM_FIELDS][key] = data[PIM_DEBTOR_GROUP_DETAIL_FIELD_KEY.CUSTOM_FIELDS][key];
    });
  }
  return formData;
};

export {
  DebtorGroupModel,
  DebtorGroupItemModel
};
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
